export default class Root {
  constructor() {
    this.selectors = {
      adminBar: '#wpadminbar',
      footer: '.b-af-footer',
      header: '.b-af-header',
    };

    this.bootstrap();
  }

  bootstrap() {
    const adminBar = document.querySelector(this.selectors.adminBar);
    const header = document.querySelector(this.selectors.header);
    const footer = document.querySelector(this.selectors.footer);

    this.onLoadResizeScroll({
      adminBar,
      footer,
      header,
    });

    window.addEventListener(
      'resize',
      this.onLoadResizeScroll.bind(this, { adminBar, footer, header })
    );
    window.addEventListener(
      'scroll',
      this.onLoadResizeScroll.bind(this, { adminBar, footer, header })
    );
  }

  onLoadResizeScroll({ header, footer, adminBar }) {
    this.scrollBarWidth();
    this.calculateAdminBar({ adminBar });
    this.calculateHeaderHeight({ header });
    this.calculateFooterHeight({ footer });
  }

  calculateAdminBar({ adminBar }) {
    if (!adminBar) {
      return;
    }

    const styles = getComputedStyle(adminBar);

    if (styles.position === 'fixed') {
      document.documentElement.style.setProperty(
        '--admin-bar-position',
        'fixed'
      );
    }

    if (styles.position === 'absolute') {
      document.documentElement.style.setProperty(
        '--admin-bar-position',
        'absolute'
      );
    }

    document.documentElement.style.setProperty(
      '--admin-bar-height',
      `${adminBar.clientHeight}px`
    );
  }

  // eslint-disable-next-line class-methods-use-this
  scrollBarWidth() {
    document.documentElement.style.setProperty(
      '--scrollbar-width',
      `${window.innerWidth - document.documentElement.clientWidth}px`
    );
  }

  calculateHeaderHeight({ header }) {
    if (header) {
      document.documentElement.style.setProperty(
        '--header-height',
        `${header.clientHeight}px`
      );
    }
  }

  calculateFooterHeight({ footer }) {
    if (footer) {
      document.documentElement.style.setProperty(
        '--footer-height',
        `${footer.clientHeight}px`
      );
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/root.js